<template>
  <div class="delivery">
    <p class="level-2">投放方式</p>
    <div class="delivery-method-card">
      <div
        class="card"
        :class="{ active: form.mode == item.name, disabled: item.disabled }"
        v-for="(item, idx) in modeList"
        :key="idx"
        @click="handleChange(item.name)"
      >
        <p class="head">{{ item.name }}</p>
        <p class="content">{{ item.content }}</p>
      </div>
    </div>

    <div v-if="form.planHosting == '开启'">
      <p class="level-2">
        托管策略
        <el-popover placement="top" width="260" trigger="hover">
          <p style="font-size: 12px; line-height: 1.8">
            根据你的投放方式，为你提供包括计划启停、预算分配、出价调整、素材优选等调优幅度和策略。
          </p>
          <p style="font-size: 12px; line-height: 1.8">
            优先跑量：接受成本上浮，尽量消耗更多预算
          </p>
          <p style="font-size: 12px; line-height: 1.8">
            优先成本：控制成本，尽量消耗预算
          </p>
          <i class="el-icon-question" slot="reference"></i>
        </el-popover>
      </p>
      <el-radio-group v-model="form.hostingStrategy" size="medium">
        <el-radio-button label="优先跑量">优先跑量</el-radio-button>
        <el-radio-button label="优先成本">优先成本</el-radio-button>
      </el-radio-group>
    </div>

    <template v-else>
      <template v-if="isStandard">
        <div v-show="form.mode == '控成本投放'">
          <el-checkbox class="auto-checkbox" v-model="form.limit"
            >严格控制成本上限
            <el-popover placement="top" width="210" trigger="hover">
              <p style="font-size: 12px; line-height: 1.8">
                均匀投放时，实际出价相比你的目标出价会有浮动。选择严格控制上限后，实际出价尽量不会超过你的目标出价，但放量时间会有一定的加长。
              </p>
              <i class="el-icon-question" slot="reference"></i>
            </el-popover>
          </el-checkbox>
        </div>

        <div
          class="delivery-speed"
          v-show="!form.limit && form.mode != '放量投放'"
        >
          <p class="level-2">投放速度</p>
          <el-radio-group v-model="form.deliverySpeed" size="medium">
            <el-radio-button label="尽快投放"
              >尽快投放
              <el-popover placement="top" trigger="hover">
                <p style="font-size: 12px">如遇合适流量，预算集中投放</p>
                <i class="el-icon-question" slot="reference"></i>
              </el-popover>
            </el-radio-button>
            <el-radio-button label="均匀投放"
              >均匀投放
              <el-popover placement="top" trigger="hover">
                <p style="font-size: 12px; text-align: center">
                  全天预算平滑投放
                </p>
                <i class="el-icon-question" slot="reference"></i>
              </el-popover>
            </el-radio-button>
          </el-radio-group>
        </div>
      </template>

      <div class="delivery-effect">
        <div class="top-part" @click="showEffect = !showEffect">
          <p class="title">每日投放效果</p>
          <div class="btn">
            <i
              class="icon"
              :class="[
                showEffect ? 'el-icon-d-arrow-left' : 'el-icon-d-arrow-right',
              ]"
            ></i>
            <span style="font-size: 12px">{{
              showEffect ? "收起" : "展开"
            }}</span>
          </div>
        </div>
        <div class="bottom-part" v-show="showEffect">
          <el-image class="img" :src="effectImg" fit="fit"></el-image>
          <el-tooltip
            content="你每天想要消耗的上限"
            placement="top"
            effect="light"
          >
            <div class="icon-box">
              <i class="el-icon-question"></i>
            </div>
          </el-tooltip>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    form: Object,
    hideTwo: Boolean,
    isStandard: Boolean,
  },
  data() {
    return {
      modeList: [
        {
          name: "控成本投放",
          content: "优先控制成本达标，最大限度使用广告预算",
          disabled: false,
        },
        {
          name: "放量投放",
          content: "优先完成预算目标，投放过程成本会有浮动",
          disabled: false,
        },
      ],
      showEffect: false,
    };
  },
  created() {
    if (this.hideTwo) {
      this.modeList.splice(1, 1);
    }
  },
  watch: {
    "form.planHosting"(val) {
      this.modeList[1].disabled = val == "开启";
    },
  },
  computed: {
    effectImg() {
      if (this.form.mode == "放量投放")
        return require(`@/assets/images/simulation/effect_mode2.svg`);
      if (this.form.limit)
        return require(`@/assets/images/simulation/effect_mode3.svg`);
      else {
        if (this.form.deliverySpeed == "尽快投放")
          return require(`@/assets/images/simulation/effect_mode1.svg`);
        else return require(`@/assets/images/simulation/effect_mode1.1.svg`);
      }
    },
  },
  methods: {
    handleChange(name) {
      if (this.form.planHosting == "开启") return;
      this.form.mode = name;
    },
  },
};
</script>

<style lang="less" scoped>
.delivery {
  .level-2 {
    margin-top: 28px;
    margin-bottom: 12px;
    line-height: 20px;
    font-weight: 600;
    font-size: 14px;
    color: #333;
  }

  .el-icon-question {
    margin-left: 3px;
    color: #d3d3d3;
    font-size: 16px;
    vertical-align: -1px;
    cursor: pointer;
  }
  ::v-deep  .el-radio-group {
    .el-radio-button__inner {
      padding-left: 15px;
      padding-right: 15px;
      min-width: 100px;
      height: 34px;
      background: #f2f2f2;
      border: 1px solid transparent;
      color: #333;

      // border-radius: 4px;
      &:hover {
        background-color: #eff0fe;
      }
    }

    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      color: #194ce5;
      border: 1px solid #194ce5;
      background-color: #fff;
      box-shadow: none;
    }
  }
  ::v-deep .auto-checkbox {
    margin-top: 15px;

    .el-checkbox__inner {
      width: 16px;
      height: 16px;

      &:hover {
        border-color: #333;
      }

      &::after {
        left: 5px;
      }
    }

    .el-checkbox__label {
      padding-left: 5px;
      line-height: 20px;
      font-size: 14px;
      color: #333;
    }

    &.is-checked {
      .el-checkbox__inner {
        background-color: #333;
        border-color: #333;
      }

      .el-checkbox__label {
        color: inherit;
      }
    }

    .el-checkbox__input.is-focus {
      .el-checkbox__inner {
        border-color: #333;
      }
    }
  }
  .delivery-method-card {
    .card {
      display: inline-block;
      padding: 8px 16px;
      margin-right: 25px;
      width: 311px;
      height: 57px;
      border: 1px solid transparent;
      border-radius: 4px;
      background-color: #f2f2f2;
      user-select: none;
      cursor: pointer;

      &:hover {
        background-color: #edf1fd;
      }

      &.active {
        border: 1px solid #194ce5;
        background-color: #fff;
        box-shadow: 0 0 2px rgba(0, 0, 0, 10%);
      }

      &.disabled {
        opacity: 0.3;
        cursor: not-allowed;
        &:hover {
          background-color: #f2f2f2;
        }
      }

      .head {
        line-height: 20px;
        font-weight: 500;
        font-size: 14px;
        color: #333;
      }

      .content {
        line-height: 17px;
        font-size: 12px;
        color: #999;
      }
    }
  }

  .delivery-effect {
    margin-top: 15px;
    padding: 8px 16px;
    border: 1px solid #e3e3e4;
    border-radius: 4px;
    width: 648px;
    .top-part {
      overflow: hidden;
      cursor: pointer;
      .title {
        float: left;
        margin-top: 3px;
        line-height: 17px;
        vertical-align: 3px;
        font-weight: 600;
        font-size: 12px;
      }
      .btn {
        float: right;
        margin-top: 3px;
        .icon {
          margin-right: 5px;
          font-weight: bold;
          transform: rotate(90deg);
        }
      }
    }
    .bottom-part {
      position: relative;
      margin-top: 12px;
      .icon-box {
        position: absolute;
        left: 369px;
        top: 167px;
        width: 16px;
        height: 16px;
        background-color: #fff;
        .el-icon-question {
          font-size: 16px;
          color: #e3e3e4;
          z-index: 22;
        }
      }
    }
  }
}
</style>